import * as React from 'react';
import './MobileBookSection.css';

export enum MobileBookSectionEnum {
	Collections,
	ReadNow,
	WantRead,
	AlreadyRead
}

interface Props {
	header?: string;
	moreText?: React.ReactNode;
}

const MobileBookSection: React.FC<Props> = props => {
	return <div className="mobile-books__section">
		{props.header && <div className="header__wrapper">
			{props.header}

			{props.moreText && <div>
				{props.moreText}
			</div>}
		</div>}

		<div>
			{props.children}
		</div>
	</div>
};

export default MobileBookSection;
